import React from 'react';
import './footer.css';


const Footer = () => {
    return (
        <footer className='footer'>
                <div className='center'>
                    This is a work in progress.
                    If you would like to report any issues please see Contact Me.
                </div>
                <div className='center'>
                    Copyright &#169; 2024 Mitchell Neat. All rights Reserved.
                </div>
                
        </footer>
    );
    }

export default Footer;